import { computed, Injectable, signal } from '@angular/core';
import { Role, UserAccess } from './core/models/permission.model';
import { PermissionActions } from './shared/constants/permissions';
@Injectable({
  providedIn: 'root',
})
export class FlowService {
  bytes: any;
  private _permissions = signal<UserAccess>({} as UserAccess);
  private _role = signal<Role | undefined>(undefined);
  // Signals for computed properties
  permission = computed(() => this._permissions());
  role = computed(() => this._role());

  isSuperAdmin$ = computed(() => this.role() === 'SUPER_ADMIN');

  checkReadPermission$ = (permission: string) =>
    computed(() => this.checkPermission(permission, PermissionActions.READ));

  checkWritePermission$ = (permission: string) =>
    computed(() => this.checkPermission(permission, PermissionActions.WRITE));

  checkDeletePermission$ = (permission: string) =>
    computed(() => this.checkPermission(permission, PermissionActions.DEL));

  checkEditPermission$ = (permission: string) =>
    computed(() => this.checkPermission(permission, PermissionActions.EDIT));

  public setRole() {
    this._role.set(localStorage.getItem('role') as Role);
  }

  public setPermission() {
    this._permissions.set(
      JSON.parse(localStorage.getItem('permission') || '{ }')
    );
  }

  public hasPermissions() {
    if (this.permission() && Object.keys(this.permission()).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  private checkPermission(
    permission: string,
    permissionKey: 'read' | 'create' | 'delete' | 'edit' = 'read'
  ): boolean {
    const perms = this.permission();
    return !!perms[permissionKey]?.find((e) => e.accessKey === permission);
  }
}
